# frozen_string_literal: true

# Frozen copy of Vogel's Scheme of 1870 at playtest commit 372915020 (2026-10-06).
# Never edit it: rule changes go into the current version. See CHANGELOG.playtest.md.

require_relative '../meta'

module Engine
  module Game
    module GVogel1870V1
      module Meta
        include Game::Meta

        DEV_STAGE = :alpha
        PROTOTYPE = true

        GAME_TITLE = "Vogel's Scheme of 1870 v1"
        GAME_SUBTITLE = 'and the Railways of New Zealand'
        GAME_DESIGNER = 'Joshua Starr'
        GAME_IMPLEMENTER = 'Alexander Potapov'
        GAME_LOCATION = 'New Zealand'
        GAME_PUBLISHER = :grand_trunk_games
        GAME_RULES_URL = 'https://docs.google.com/document/d/1lLL6n48GNYh0sBA6JgXMw69S4_IXptF0UIzMQrQj9jk/'

        PLAYER_RANGE = [3, 5].freeze
      end
    end
  end
end
